// extracted by css-extract-rspack-plugin
export default {"codeInputField":"codeInputField-v2Bvp0"};